import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const Label = (props) => {
    return(
      <tr>
        <td>
          <NavLink to={`/inventory/${props.box.id}`}>
            {props.box.id}
          </NavLink>
        </td>
        <td className="hidden-xxs-down">{props.invoice.vendor.name}</td>
        <td className="hidden-xs-down">{props.box.brand}</td>
        <td className="hidden-xs-down">{props.box.packingDate}</td>
        <td>{props.box.item}</td>
        <td className="hidden-xs-down">{props.box.weight}</td>
        <td className="hidden-xs-down">{props.box.pieces}</td>
        <td>
          {!props.box.itemIsBarcode &&
            <span className="btn btn-info" onClick={()=>props.printLabel(props.index)}>
              <i className="fa fa-print"></i>
            </span>
          }
        </td>
      </tr>
    )
}

export default class LabelList extends Component {
  render() {
    return (
      <tbody>
        {this.props.boxes.map((box,index)=>{
          return(
            <Label invoice={this.props.invoice} box={box} index={index} printLabel={this.props.printLabel} key={index}/>
          )
        })}
      </tbody>
    )
  }
}
